import Api from '@/api'
import Store from '@/store'

import Storage from '@/helpers/storage'

import I18n from '@/modules/i18n'
import Loop from '@/modules/loop'
import Tag from '@/modules/tag'
import Tracking from '@/modules/tracking'
import UserAgent from '@/modules/userAgent'

const auth = {

    checkAuth: function (to, from, next) {

        if (Storage.getItem('token')) {

            Store.dispatch('getUserAsync')
                .then(user => {

                    if (to.fullPath === '/user-form') {

                        next()

                    } else if (user && (!user.firstname || !user.lastname || (!user.birthYear || user.birthYear < 1))) {

                        next({ path: '/user-form' })

                    } else if (Storage.getItem('fetchStatus') !== 'done' && to.fullPath !== '/settings' && to.fullPath !== '/fetch' && to.fullPath !== '/add-inbox') {

                        next({ path: '/fetch' })

                    } else {

                        next()

                    }

                })
                .catch(error => {
                    auth.disconnect()
                })

        } else {

            auth.disconnect()

        }

    },

    checkNotAuth: function (to, from, next) {

        Storage.getItem('token') ? next({ path: '/newsletters' }) : next()

    },

    redirect: function (to, from, next) {

        Storage.getItem('token') ? next({ path: '/newsletters' }) : auth.disconnect()

    },

    connect: function (Vue, email, password) {

        const device = UserAgent.getDevice()

        const language = I18n.get(Vue)

        return Api.auth.connect(email, password, device, language)
            .then(data => {

                return postConnection(Vue, data.token)

            })
    },

    disconnect: function () {
        Api.auth.disconnect()
        if (Store) { // fixme: Iphone crash
            Store.dispatch('disconnect')
        }
        Storage.clear()
        location.href = '/'

    },

    sendMagicLinkEmail: function (email) {

        const lang = localStorage.getItem('lang') || 'en'

        return Api.auth.sendMagicLinkEmail(email, lang)

    },

    getMagicLinkUser: function (code) {

        return Api.auth.getMagicLinkUser(code)

    },

    getAuthLink: function (code) {

        return Api.auth.authLongCheck(code)

    },

    deleteEmailAccount: function (email) {

        return Api.auth.deleteEmailAccount(email)
            .then(data => {
                Storage.setItem('aToken', data.token)
                sessionStorage.setItem('cleanfoxEmail', email)
                return Loop.start(Api.auth.deleteEmailAccountCheck)
            })

    },

    microsoftAuth: async function (Vue, aToken) {

        return await postConnection(Vue, aToken)

    },

    microsoftApi: function (Vue, email) {

        Tag.pageViewAmplitude(Vue, 'microsoft')

        const token = Storage.getItem('token') || ''
        const emailStr = encodeURIComponent(email) || ''
        const utmSource = Storage.getItem('utm_source') || ''
        const utmMedium = Storage.getItem('utm_medium') || ''
        const utmCampaign = Storage.getItem('utm_campaign') || ''
        const referrer = Storage.getItem('referrer') || ''
        const device = UserAgent.getDevice()
        const language = I18n.get(Vue)

        window.location.href = `/login/microsoft?token=${token || ''}&email=${emailStr}&utm_source=${utmSource}&utm_medium=${utmMedium}&utm_campaign=${utmCampaign}&referrer=${referrer}&device=${ device }&language=${ language }`

    },

    validConsent: function (lang, email) {

        const utms = Tracking.getTracking()

        const body = {
            email,
            language: lang,
            device: UserAgent.getDevice()
        }

        return Api.auth.validConsent(body, utms)

    }

}

export default auth

function postConnection (Vue, aToken) {

    Storage.setItem('aToken', aToken)

    return Loop.start(Api.auth.authCheck)
        .then(result => {

            Storage.setItem('token', result.token)
            Store.dispatch('setUser', result.user)

            const provider = result.user.accounts[0].provider
            const hash = result.user.hash

            if (result.new) {
                Tag.accountCreated(provider, hash)
                Tag.accountCreatedAmplitude(Vue, provider)
            }

            if (result.association) {
                Tag.accountAssociated()
                Tag.accountAssociatedAmplitude(Vue)
            }

        })

}
